export default "__VITE_ASSET__2fRZaoLQ__"